export const translatableLangs = [
  { id: 'es', value: 'Es', label: 'Castellano' },
  { id: 'ca', value: 'Ca', label: 'Català' },
  // { id: 'en', value: 'En', label: 'English' },
];
